<div class="local-search-wrapper" [ngClass]="class">
  <span class="a-local-search-label" *ngIf="label">{{label}}</span>
  <div class="a-local-search">
    <p-autoComplete [suggestions]="top100results" [ngModel]="searchKey" (completeMethod)="search($event)"
      (onClear)="clearSearch()" [field]="field" [placeholder]="placeholder" [disabled]="disabled">
    </p-autoComplete>
    <i class="fa fa-search a-local-search-icon" [class.disabled]="disabled"></i>
  </div>
</div>
